import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Is Pankaj singh legally liable for third-party services or tools?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Pankaj singh is not liable for issues arising from third-party tools, themes, plugins, hosting, or external websites linked from our site."
      }
    },
    {
      "@type": "Question",
      "name": "Does the website guarantee 24/7 uptime and availability?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "While we aim for high availability, we do not guarantee 24/7 uptime. Temporary downtime may occur due to maintenance, server issues, or third-party disruptions."
      }
    },
    {
      "@type": "Question",
      "name": "Can the information on the website be used as legal or business advice?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. All content on the website is for general informational purposes only and should not be considered legal, financial, or professional advice."
      }
    },
    {
      "@type": "Question",
      "name": "Can this disclaimer be updated?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Pankaj singh reserves the right to modify this disclaimer at any time without prior notice. Visitors should review the disclaimer periodically."
      }
    }
  ]
}


function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Disclaimer – Website Designers In Gurgaon</title>
<meta name="description" content="Read the disclaimer for Pankaj Web Design. Understand limitations of liability, third-party links, and service use before hiring our freelance web development services in Gurgaon." />
<meta name="keywords" content="disclaimer, pankaj web designer, freelance developer, website service disclaimer, website legal notice, limitations of liability, website terms, gurgaon" />
<meta property="og:title" content="Disclaimer – Website Designers in Gurgaon | Pankaj Web Design" />
<meta property="og:description" content="This disclaimer outlines the limitations and responsibilities of using services and content provided by Pankaj Web Design in Gurgaon." />
<meta property="og:url" content="https://www.pankj.com/disclaimer" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Disclaimer – Website Designers in Gurgaon" />
<meta name="twitter:description" content="Understand the scope and limitations of our website design services before hiring Pankaj Web Design." />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<link rel="canonical" href="https://www.pankj.com/disclaimer" />
</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects" id="text3d">Disclaimer</h1>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.webp" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   
    <main id="main">
<section id="pageContent" className="pageContent">
      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Disclaimer</h2>
        </header>
        <div className="row">
          <div className="col-lg-12">
        <p><strong>Effective Date:</strong> July 12, 2025</p>
        <p><strong>Website:</strong> <a href="https://www.pankj.com">www.pankj.com</a></p>
        <p><strong>Contact:</strong> <a href="mailto:info@pankj.com">info@pankj.com</a></p>

        <h2 className="text-xl font-semibold mt-6">1. General Information</h2>
        <p>
          The information provided on this website is for general informational purposes only. While we strive to keep the content accurate and up to date, we make no warranties or guarantees about the completeness, reliability, or suitability of the information and services offered.
        </p>

        <h2 className="text-xl font-semibold mt-6">2. Professional Advice</h2>
        <p>
          The content on this website does not constitute legal, financial, or professional advice. Users should consult qualified professionals for specific advice related to their needs or business.
        </p>

        <h2 className="text-xl font-semibold mt-6">3. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites or tools. These links are provided for convenience, and we are not responsible for the content, privacy policies, or accuracy of information on external sites.
        </p>

        <h2 className="text-xl font-semibold mt-6">4. Limitation of Liability</h2>
        <p>
          Pankaj Singh is not liable for any losses, damages, or disruptions resulting from the use of our website or services. This includes but is not limited to errors, outages, malware, third-party failures, or data loss.
        </p>

        <h2 className="text-xl font-semibold mt-6">5. Service Availability</h2>
        <p>
          While we strive to maintain uninterrupted access to our website and services, we do not guarantee availability or functionality at all times. Scheduled maintenance, technical issues, or unforeseen disruptions may occur.
        </p>

        <h2 className="text-xl font-semibold mt-6">6. Content Ownership</h2>
        <p>
          All text, code, images, and media on this website are owned by Pankaj Singh unless otherwise credited. Unauthorized use, reproduction, or distribution is prohibited without prior written consent.
        </p>

        <h2 className="text-xl font-semibold mt-6">7. Changes to This Disclaimer</h2>
        <p>
          We reserve the right to update or change this Disclaimer at any time without notice. It is the user’s responsibility to review this page periodically.
        </p>

        <h2 className="text-xl font-semibold mt-6">8. Contact</h2>
        <p>
          If you have any questions regarding this disclaimer, please contact us at: <br />
          <strong>Email:</strong> <a href="mailto:info@pankj.com">info@pankj.com</a><br />
          <strong>Website:</strong> <a href="https://www.pankj.com">www.pankj.com</a>
        </p>

          </div>

        </div>
      </div>

    </section>    <Contact /> 
    </main>
    </>
  );
}
export default App1;
